import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { supabase } from '../Config/Config';
import { FiSettings, FiX } from "react-icons/fi";
import { CgMenuLeftAlt } from "react-icons/cg";
import { IoLogOutOutline } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { FaUserEdit } from "react-icons/fa";
import { IoIosSearch } from "react-icons/io";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [user, setUser] = useState(null);
    const [activeDropdown, setActiveDropdown] = useState(false);
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setActiveDropdown(!activeDropdown); // Toggle specific dropdown
    };

    useEffect(() => {
        const checkUser = async () => {
            const { data: { session } } = await supabase.auth.getSession();
            setUser(session?.user ?? null);
        };

        checkUser();

        const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
            setUser(session?.user ?? null);
        });

        return () => {
            authListener.subscription.unsubscribe();
        };
    }, []);

    const handleLogout = async () => {
        try {
            const { error } = await supabase.auth.signOut();
            if (error) throw error;
            navigate('/signin');
        } catch (error) {
            console.error('Error logging out:', error.message);
        }
    };

    const handleMenuToggle = () => {
        setIsOpen(!isOpen);
    };

    const linkStyles = "text-md ml-[15px] my-[8px] border-black border-2 hover:border-white px-[8px] py-[5px] flex items-center font-medium rounded-xl";
    const activeLinkStyles = "bg-white text-black";

    return (
        <nav className="z-50">
            <div className="w-full h-[80px] fixed p-4 bg-black flex items-center justify-between z-50">
                <div className="flex justify-between w-full items-center">

                    <button className="xsx:hidden text-white" onClick={handleMenuToggle}>
                        {isOpen ? <FiX size={24} /> : <CgMenuLeftAlt size={24} />}
                    </button>

                    <div className="xsx:flex hidden text-md items-center text-white">
                        <NavLink to="/" className={({ isActive }) => `${linkStyles} ${isActive ? activeLinkStyles : ""}`}> Home</NavLink>
                        <NavLink to="/techtoday" className={({ isActive }) => `${linkStyles} ${isActive ? activeLinkStyles : ""}`}> TechToday</NavLink>
                        <NavLink to="/products" className={({ isActive }) => `${linkStyles} ${isActive ? activeLinkStyles : ""}`}> Gadgets</NavLink>
                    </div>

                    <div className="text-white font-serif text-2xl px-[8px] xsx:mr-[105px] lg:mr-[185px] xl:mr-[145px] py-[2px] rounded-xl">TechVenture</div>
                    <NavLink to="/searchprojects" className="xsx:hidden block text-white"><IoIosSearch size={30} /></NavLink>
                    {/*
 <details className="text-white cursor-pointer xsx:block hidden">
                            <summary className="text-white list-none mr-[10px] text-md p-[10px] hover:bg-white hover:text-black border-2 border-white rounded-full"><FaUserEdit className="text-[25px]" /></summary>
                            <div className="absolute mt-[20px] ml-[-165px] p-[8px] w-[210px] list-none bg-white border-4 rounded-xl shadow-custom-slider text-black">
                                <button className="text-red cursor-pointer-500 w-[100%] text-[22px] px-[12px] py-[6px] font-medium flex items-center hover:bg-red-700 hover:text-white rounded-xl border-2 border-white" onClick={handleLogout}><IoLogOutOutline className="text-[29px] mt-[4px] mr-[3px]" /><p>Logout</p></button>
                                <NavLink to="/profile" className="text-black-500 w-[100%] text-[22px] px-[12px] py-[6px] font-medium flex items-center hover:bg-gray-800 hover:text-white rounded-xl border-2 border-white"><FaUserEdit className="text-[28px] mt-[4px] mr-[6px]" /><p>My Profile</p></NavLink>
                            </div>
                        </details>
*/}
                    {user ? (
                        <>
                            <button onClick={() => toggleDropdown()} className="text-white list-none mr-[10px] text-md p-[10px] hover:bg-white hover:text-black border-2 border-white rounded-full">
                                <FaUserEdit className="text-[25px]" />
                            </button>
                            {activeDropdown &&
                                <div onClick={() => toggleDropdown()} className="absolute right-10 mt-[150px] w-[180px] bg-white border border-gray-200 rounded-md shadow-lg z-10">
                                    <NavLink to="/profile" className="flex text-[17px] items-center w-full text-left px-4 py-2 text-gray-800 font-[600] hover:bg-gray-200 hover:text-gray-800">
                                        <FiSettings size={17} className="mr-2" /> My Profile
                                    </NavLink>
                                    <button onClick={handleLogout} className="flex items-center w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-200 font-[600] hover:text-red-800">
                                        <IoLogOutOutline className="mr-2" /> Logout
                                    </button>
                                </div>
                            }
                        </>

                    ) : (
                        <NavLink to="/signin" className="text-white xsx:flex hidden text-lg px-[8px] py-[2px] font-medium items-center hover:bg-white hover:text-black rounded-xl border-2 border-white" onClick={handleLogout}><IoLogOutOutline className="text-[25px] mt-[3px] mr-[3px]" /><p>Register</p></NavLink>
                    )}

                </div>
            </div>

            <div className="relative bg-black md:hidden">
                <AnimatePresence>
                    {isOpen && (
                        <motion.div
                            initial={{ y: -100, height: 0 }}
                            animate={{ y: 0, height: "100vh", transition: { duration: 0.8 } }}
                            exit={{ y: -100, height: 0, transition: { duration: 0.5, delay: 0.3 } }}
                            className="fixed inset-0 bg-black flex flex-col h-screen px-4 py-3 z-40"
                            onClick={handleMenuToggle}
                        >
                            <div className='my-[25px]'></div>
                            {/* Menu items */}
                            <motion.div
                                initial={{ x: -100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1, transition: { duration: 0.5, delay: 0.8 } }}
                                exit={{ x: -100, opacity: 0, transition: { duration: 0.3 } }}
                                className="flex h-full pb-12 flex-col mt-10"
                                onClick={handleMenuToggle}
                            >
                                <NavLink to="/" className="font-medium w-[85%] rounded-lg bg-gray-800 mx-auto py-[5px] text-[18px] text-center text-slate-300 mb-[15px] cursor-pointer">Home</NavLink>
                                <NavLink to="/techtoday" className="font-medium w-[85%] rounded-lg bg-gray-800 mx-auto py-[5px] text-center text-[18px] text-slate-300 mb-[15px] cursor-pointer">Tech Today</NavLink>
                                <NavLink to="/products" className="font-medium w-[85%] rounded-lg bg-gray-800 mx-auto py-[5px] text-center text-[18px] text-slate-300 mb-[15px] cursor-pointer">Gadgets</NavLink>
                                <NavLink to="/profile" className="font-medium w-[85%] rounded-lg bg-[#313030] mx-auto py-[5px] text-center text-[18px] text-white mb-[15px] cursor-pointer">Profile</NavLink>

                                {user ? (
                                    <button className="font-medium w-[85%] mt-auto flex items-center rounded-lg mx-auto justify-center py-[10px] text-[18px] text-center text-slate-300 mb-[15px] bg-red-900 cursor-pointer" onClick={handleLogout}><IoLogOutOutline className="text-[25px] mt-[3px] mr-[3px]" /><p>Logout</p></button>
                                ) : (
                                    <NavLink onClick={handleMenuToggle} to="/signin" className="font-medium w-[85%] flex items-center py-[10px] justify-center rounded-lg mt-auto border border-gray-700 mx-auto  text-[18px] text-center text-slate-300 mb-[15px] cursor-pointer"><IoLogOutOutline className="text-[28px] mr-[3px]" /><p>Get Started</p></NavLink>
                                )}
                            </motion.div>

                        </motion.div>
                    )}
                </AnimatePresence>
            </div>

        </nav>
    );
};

export default Navbar;
